<span #stickyPopover="stickyPopover"
      [stickyPopover]="popContent"
      [popoverTitle]="popTitle"
      [autoClose]="'outside'"
      [animation]="false"
      [openDelay]="300"
      popoverClass='sky-object-popover'
      container="body"
      triggers="manual"
      placement="auto">
</span>

<ng-template #popTitle>
  <i class="fa-solid fa-circle text-primary me-1"></i>Sky object {{skyObject.mainId}}
</ng-template>

<ng-template #popContent>
  <ul class="list list-unstyled mb-0">
    <li><strong>Main id</strong>:
      <ng-container *ngIf="skyObject.resolverType === 'SIMBAD'">
        <a href="{{simbadOjectUrl}}{{encodeURIComponent(skyObject.mainId)}}" target="_blank">{{skyObject.mainId}}</a>
      </ng-container>
      <ng-container *ngIf="skyObject.resolverType === 'NED'">
        <a href="{{nedObjectUrl}}{{encodeURIComponent(skyObject.mainId)}}" target="_blank">{{skyObject.mainId}}</a>
      </ng-container>
    </li>
    <li><strong>RA Dec</strong>: {{skyObject.ra | raHms }} {{skyObject.dec | decDms }}</li>
    <li *ngIf="skyObject.radvel"><strong>Radvel</strong>: {{skyObject.radvel}}</li>
    <li><strong>Long type</strong>: {{skyObject.longtype}}</li>
    <li><strong>Resolver type</strong>: {{skyObject.resolverType}}</li>
  </ul>
</ng-template>
